/* eslint-disable @typescript-eslint/no-empty-function */
import {
  useGetTaskGroup,
  usePermissions,
  useUpsertTaskGroup,
} from '@dispatch/shared/hooks';
import { TaskGroup } from '@dispatch/shared/types';
import { useCurrentUser } from '@dispatch/web/auth';
import { TaskGroupDetails } from '@dispatch/web/features/task-groups';
import { useNotificationMutationFactory } from '@dispatch/web/ui';
import { useParams } from 'react-router-dom';

const TaskGroupDetailsPage = () => {
  const { permissions } = usePermissions();
  const params = useParams();
  const { tenantId } = useCurrentUser();
  const taskGroupId: string = params['taskGroupId'] || '';
  const { data: taskGroup, status } = useGetTaskGroup(taskGroupId);
  const { notifySuccess } = useNotificationMutationFactory(
    'Task Group',
    'update'
  );
  const { upsertTaskGroup, status: mutateStatus } = useUpsertTaskGroup(
    taskGroupId,
    notifySuccess
  );

  const handleSave = (value: TaskGroup) => {
    value.tenantId = tenantId || '';
    upsertTaskGroup(value);
  };

  const handleActivate = (value: TaskGroup) => {
    value.deactivatedAt = null;
    upsertTaskGroup(value);
  };

  const handleDeactivate = (value: TaskGroup) => {
    value.deactivatedAt = new Date().toISOString();
    upsertTaskGroup(value);
  };

  return (
    <TaskGroupDetails
      onSave={handleSave}
      status={mutateStatus === 'loading' ? mutateStatus : status}
      data={taskGroup?.data}
      permissions={permissions}
      onActivate={handleActivate}
      onDeactivate={handleDeactivate}
    />
  );
};

export default TaskGroupDetailsPage;
